import { render, staticRenderFns } from "./CustomerTwism.vue?vue&type=template&id=43388f97&"
import script from "./CustomerTwism.vue?vue&type=script&lang=ts&"
export * from "./CustomerTwism.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports